'use strict';

module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/react/15.3.2/react/react.js
 ** module id = 90
 ** module chunks = 0
 **/